/**
 * How long an entry ran, written the way the timesheet writes it: "2h 30m",
 * "45m", "0m".
 *
 * Shared rather than local to a component because the delete confirmation has
 * to state the same length as the row it was opened from. `report-print.ts`
 * has a formatter of its own, and it is the wrong one here: it always prints
 * both units, so a 45-minute row would be confirmed as "0h 45m" and a
 * 12-second one — a shape the Edit dialog explicitly handles — as "0h 0m", a
 * dialog claiming the entry it is about to destroy has no length. That
 * formatter stays where it is; the exported report is a document with its own
 * conventions, and columns of "0h 45m" line up where "45m" does not. [HW-843]
 */
export function formatEntryDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h === 0 && m === 0) return '0m';
  if (h === 0) return `${m}m`;
  return `${h}h ${m}m`;
}
